
import Vue from 'vue';
import {ListingDetailInterface} from '~/store/listing'

export default Vue.extend({
  name: 'ChefImageCard',
  props: {
    chefId: {
      type: String,
      required: true
    }
  },
  computed: {
    chef(): ListingDetailInterface | undefined {
      return this.$store.getters['listing/byIdOrSlug'](this.chefId)
    },
  },
  data() {
    return {
      selectedImage: 0,
      showAllImages: false,
    }
  },
  methods: {
    selectOrOpen(index: number) {
      if (index === 4 && !this.showAllImages && this.chef && this.chef.images.length > 5) {
        this.showAllImages = true;
      } else {
        this.selectedImage = index;
      }
    }
  }
})
